export default __webpack_public_path__ + "static/media/Support-avatar_32.2347af2f.svg";